import * as React from 'react';
const Svg3DCube = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.559 2.421a3.09 3.09 0 0 0-3.118 0L4.56 5.848A3.15 3.15 0 0 0 3 8.573v6.854c0 1.124.594 2.163 1.559 2.724l5.882 3.427a3.09 3.09 0 0 0 3.118 0l5.882-3.427A3.15 3.15 0 0 0 21 15.427V8.573a3.15 3.15 0 0 0-1.559-2.725zm1.577 3.234L13.005 6.91a2 2 0 0 1-2.014.008L8.834 5.672 5.95 7.352 12 10.846l6.05-3.493zM5 12.768V9.113l6 3.464v7.012l-3-1.747v-2.187a2 2 0 0 0-1-1.732zm14-3.655-6 3.464v7.012l3-1.747v-2.187a2 2 0 0 1 1-1.732l2-1.155z"
      clipRule="evenodd"
    />
  </svg>
);
export default Svg3DCube;
